import { createActionFactory } from '../../common/redux';

const { createAction, createApiFailureAction } = createActionFactory('Campaign Promotion => ');

const fetchPromotions = createAction('fetch promotions', (isMicroExperience) => ({ isMicroExperience }));
const fetchPromotionsSuccess = createAction('successfully fetched promotions', (promotions) => ({ promotions }));
const fetchPromotionsFailure = createApiFailureAction('failed to fetch promotions');

const sortPromotions = createAction('sort promotions', (sort) => ({ sort }));

const createPromotionFromTemplate = createAction('create promotion from template');
const addPromotionTemplateToTheList = createAction('add promotion template to the list', (promotionTemplate) => ({
  promotionTemplate,
}));

const clonePromotion = createAction('clone promotion', (id, name) => ({ id, name }));
const clonePromotionSuccess = createAction('successfully cloned promotion', (promotion) => ({ promotion }));
const clonePromotionFailure = createApiFailureAction('failed to create promotion');

const publishPromotion = createAction('publish promotion', (id) => ({ id }));
const publishPromotionSuccess = createAction('successfully published promotion', (promotion, successMessage) => ({
  promotion,
  successMessage,
}));
const publishPromotionFailure = createApiFailureAction('failed to publish promotion');

const draftPromotion = createAction('draft promotion', (id) => ({ id }));
const draftPromotionSuccess = createAction('successfully drafted promotion', (promotion, successMessage) => ({
  promotion,
  successMessage,
}));
const draftPromotionFailure = createApiFailureAction('failed to draft promotion');

const attemptEditPromotion = createAction('attempt edit promotion', (id) => ({ id }));
const editPromotion = createAction('edit promotion', (id) => ({ id }));
const cancelEditPromotion = createAction('cancel edit promotion');
const cancelPromotion = createAction('cancel promotion');

const persistPromotions = createAction('persist promotions', (saveAndClose) => ({ saveAndClose }));
const persistPromotionsSuccess = createAction(
  'persist promotions success',
  (promotions, successMessage, closeEditor = true) => ({
    promotions,
    successMessage,
    closeEditor,
  })
);
const persistPromotionsFailure = createApiFailureAction('persist promotions failure', (error) => ({ error }));

const takePromotionsSnapshot = createAction('take promotions snapshot');
const openPromotionEditor = createAction('open promotion editor', (id) => ({ id }));

const deletePromotion = createAction('delete promotion', (id) => ({ id }));
const deletePromotionSuccess = createAction('successfully deleted promotion', (id, successMessage) => ({
  id,
  successMessage,
}));
const deletePromotionFailure = createApiFailureAction('failed to delete promotion');

const editPromotionLayout = createAction('edit promotion layout', (id) => ({ id }));
const editPromotionLayoutSuccess = createAction('successfully edited promotion layout');
const editPromotionLayoutFailure = createAction('failed to edit promotion layout');

const toggleClonePromotionModal = createAction('toggle clone promotion modal', (id) => ({ id }));

const showConfirmDeleteMessage = createAction('show confirm delete message', (id) => ({ id }));
const hideConfirmDeleteMessage = createAction('hide confirm delete message');

const setActiveEditPanel = createAction('set active edit panel', (panel) => ({ panel }));
const setVisibilityDiscardChangesModal = createAction('cancel reward', (isVisible) => isVisible);

const setCloningPromotion = createAction('set cloning promotion', (promotion) => ({ promotion }));

const changePromotion = createAction('change promotion', (key, value) => ({ key, value }));
const changePromotionDisplayStrategy = createAction('change promotion display strategy', (value) => ({ value }));
const changePromotionDetailStrategy = createAction('change promotion detail strategy', (value) => ({ value }));

const savePromotion = createAction('change promotion', (promotion) => ({ promotion }));

const dismissSuccessMessage = createAction('dismiss success message');

export default {
  fetchPromotions,
  fetchPromotionsSuccess,
  fetchPromotionsFailure,

  sortPromotions,

  clonePromotion,
  toggleClonePromotionModal,
  clonePromotionSuccess,
  clonePromotionFailure,

  createPromotionFromTemplate,
  addPromotionTemplateToTheList,

  publishPromotion,
  publishPromotionSuccess,
  publishPromotionFailure,

  draftPromotion,
  draftPromotionSuccess,
  draftPromotionFailure,

  attemptEditPromotion,
  editPromotion,
  cancelEditPromotion,
  cancelPromotion,

  openPromotionEditor,
  takePromotionsSnapshot,

  deletePromotion,
  deletePromotionSuccess,
  deletePromotionFailure,

  showConfirmDeleteMessage,
  hideConfirmDeleteMessage,

  editPromotionLayout,
  editPromotionLayoutSuccess,
  editPromotionLayoutFailure,

  persistPromotions,
  persistPromotionsSuccess,
  persistPromotionsFailure,

  setActiveEditPanel,
  setVisibilityDiscardChangesModal,

  setCloningPromotion,
  changePromotion,
  changePromotionDisplayStrategy,
  changePromotionDetailStrategy,

  savePromotion,

  dismissSuccessMessage,
};
